// misc
export const SET_IS_IN_PAGE_SEARCH_ENABLED = 'SET_IS_IN_PAGE_SEARCH_ENABLED';
export const SET_SIDEBAR_EXPANSION_SIZE = 'SET_SIDEBAR_EXPANSION_SIZE';

// theme
export const SET_IS_THEME_SELECTOR_OPEN = 'SET_IS_THEME_SELECTOR_OPEN';
export const SET_IS_STYLE_SELECTOR_OPEN = 'SET_IS_STYLE_SELECTOR_OPEN';
export const SET_IS_PAGE_SCOPED_CSS_EDITOR_OPEN = 'SET_IS_PAGE_SCOPED_CSS_EDITOR_OPEN';
export const SET_IS_SHOWING_COMPATIBLE_THEMES = 'SET_IS_SHOWING_COMPATIBLE_THEMES';

// header
export const SET_IS_HEADER_EDITOR_OPEN = 'SET_IS_HEADER_EDITOR_OPEN';
export const SET_TEMPORARY_PAGE_TITLE = 'SET_TEMPORARY_PAGE_TITLE';
export const CLOSE_PAGE_TITLE_EDITOR = 'CLOSE_PAGE_TITLE_EDITOR';
export const SET_IS_SECONDARY_LOGO_ENABLED = 'SET_IS_SECONDARY_LOGO_ENABLED';
export const SET_SECONDARY_LOGO_DATA = 'SET_SECONDARY_LOGO_DATA';
export const SET_PAGE_NAME = 'SET_PAGE_NAME';
export const OPEN_PAGE_TITLE_EDITOR = 'OPEN_PAGE_TITLE_EDITOR';
export const SET_SHOULD_SHOW_HEADER = 'SET_SHOULD_SHOW_HEADER';
export const SET_SHOULD_SHOW_TITLE = 'SET_SHOULD_SHOW_TITLE';
export const SET_SHOULD_SHOW_SOCIAL_LINKS = 'SET_SHOULD_SHOW_SOCIAL_LINKS';
export const SET_SOCIAL_LINKS = 'SET_SOCIAL_LINKS';
export const SET_IS_INLINE_HEADER_STYLE = 'SET_IS_INLINE_HEADER_STYLE';
export const SET_DISPLAY_ANCHOR_LINKS = 'SET_DISPLAY_ANCHOR_LINKS';
export const SET_IS_FULL_BLEED = 'SET_IS_FULL_BLEED';
export const SET_LAYOUT_HEADER_STYLE = 'SET_LAYOUT_HEADER_STYLE';
export const SET_HEADER_CONTENT_POSITIONING = 'SET_HEADER_CONTENT_POSITIONING';
export const SET_IS_USING_LEGACY_HEADER = 'SET_IS_USING_LEGACY_HEADER';

// editor 
export const ADD_SECTION = 'ADD_SECTION';
export const CLEAR_TAB_CONTENT = 'CLEAR_TAB_CONTENT';
export const SET_EDITING_TAB_ID = 'SET_EDITING_TAB_ID';
export const CLEAR_EDITING_TAB_ID = 'CLEAR_EDITING_TAB_ID';
export const SET_ACTIVE_TAB_ID = 'SET_ACTIVE_TAB_ID';
export const END_ALL_EDITING = 'END_ALL_EDITING';
export const SET_EDITING_TILE_CAPTION = 'SET_EDITING_TILE_CAPTION';
export const UPDATE_SIDEBAR_OPENED_COMPONENT_CACHE =  'UPDATE_SIDEBAR_OPENED_COMPONENT_CACHE';
export const SET_SECTION_EDITOR_CURRENT_TAB = 'SET_SECTION_EDITOR_CURRENT_TAB';

// api feeds
export const API_FEED_META_LIST_REQUEST = 'API_FEED_META_LIST_REQUEST';
export const API_FEED_META_LIST_RECEIVE_SUCCESS = 'API_FEED_META_LIST_RECEIVE_SUCCESS';
export const API_FEED_META_LIST_RECEIVE_FAILURE = 'API_FEED_META_LIST_RECEIVE_FAILURE';

export const API_FEED_REQUEST = 'API_FEED_REQUEST';
export const API_FEED_RECEIVE_SUCCESS = 'API_FEED_RECEIVE_SUCCESS';
export const API_FEED_RECEIVE_FAILURE = 'API_FEED_RECEIVE_FAILURE';

export const SET_SHOULD_SHOW_GRID_LINES = 'SET_SHOULD_SHOW_GRID_LINES';
export const QUEUE_OVERLAY_CONTENT_ITEM_FOR_DELETE = 'QUEUE_OVERLAY_CONTENT_ITEM_FOR_DELETE';
export const QUEUE_DOWNLOADABLE_CONTENT_ITEM_FOR_DELETE = 'QUEUE_DOWNLOADABLE_CONTENT_ITEM_FOR_DELETE';

export const SET_IS_GRID_TAXONOMY_ENABLED = 'SET_IS_GRID_TAXONOMY_ENABLED';
export const ADD_GRID_TAXONOMY_CATEGORY = 'ADD_GRID_TAXONOMY_CATEGORY';
export const REMOVE_GRID_TAXONOMY_CATEGORY = 'REMOVE_GRID_TAXONOMY_CATEGORY';
export const SET_GRID_TAXONOMY_CATEGORY_DATA = 'SET_GRID_TAXONOMY_CATEGORY_DATA';
export const SET_GRID_TAXONOMY_CATEGORIES_ORDER = 'SET_GRID_TAXONOMY_CATEGORIES_ORDER';
export const SET_IS_EDITING_TILE_TAXONOMY = 'SET_IS_EDITING_TILE_TAXONOMY';
export const SET_GRID_TAXONOMY_FILTER_TYPE = 'SET_GRID_TAXONOMY_FILTER_TYPE';
export const SET_GRID_TAXONOMY_FILTER_LOGICAL_OPERATOR = 'SET_GRID_TAXONOMY_FILTER_LOGICAL_OPERATOR';
export const SET_GRID_TAXONOMY_FILTER_TOGGLE_TEXT = 'SET_GRID_TAXONOMY_FILTER_LOGICAL_TOGGLE_TEXT';

// site viewer version
export const SET_SITE_VIEWER_VERSION = 'SET_SITE_VIEWER_VERSION';
export const SET_SITE_VIEWER_VERSION_META = 'SET_SITE_VIEWER_VERSION_META';
export const DISMISS_SITE_VIEWER_VERSION_UPGRADE = 'DISMISS_SITE_VIEWER_VERSION_UPGRADE';

// clipboards
export const SET_CAN_PASTE_TILE_DATA = 'SET_CAN_PASTE_TILE_DATA';
export const SET_CAN_PASTE_SECTION_DATA = 'SET_CAN_PASTE_SECTION_DATA';
export const SET_CAN_PASTE_SUBPAGE_DATA = 'SET_CAN_PASTE_SUBPAGE_DATA';
export const SET_CLIPBOARD_ITEMS_CACHE = 'SET_CLIPBOARD_ITEMS_CACHE';
export const REMOVE_CLIPBOARD_ITEMS_FROM_CACHE_BY_ID = 'REMOVE_CLIPBOARD_ITEMS_FROM_CACHE_BY_ID';

// translations
export const SET_TRANSLATIONS_IS_ENABLED = 'SET_TRANSLATIONS_IS_ENABLED';
export const SET_TRANSLATIONS_CURRENT_LANGUAGE_ISO = 'SET_TRANSLATIONS_CURRENT_LANGUAGE_ISO';
export const SET_IS_TRANSLATIONS_EDITOR_OPEN = 'SET_IS_TRANSLATIONS_EDITOR_OPEN';
export const SET_TRANSLATIONS_DEFAULT_LANGUAGE_ISO = 'SET_TRANSLATIONS_DEFAULT_LANGUAGE_ISO';
export const SET_TRANSLATIONS_APPLIED_LANGUAGES = 'SET_TRANSLATIONS_APPLIED_LANGUAGES';
export const SET_TRANSLATIONS_SELECTED_LANGUAGE_ISOS = 'SET_TRANSLATIONS_SELECTED_LANGUAGE_ISOS';
export const SET_TRANSLATION_DATA_FOR_ISO = 'SET_TRANSLATION_DATA_FOR_ISO';
export const SET_TRANSLATIONS_STATUS_FOR_ISO = 'SET_TRANSLATIONS_STATUS_FOR_ISO';
export const MASK_PAGE_ENTITIES_STATE = 'MASK_PAGE_ENTITIES_STATE';
export const MASK_CUSTOM_FOOTER_STATE = 'MASK_CUSTOM_FOOTER_STATE';
